/* tslint:disable */

const camelize = require('camelize')
const decamelize = require('decamelize-keys-deep')

const camelizeJson = (json: any): any => {
    let result: any = null

    if (typeof json === 'object') {
        result = camelize(decamelize(json))
    } else if (typeof json === 'string') {
        result = camelize(decamelize(JSON.parse(json)))
    } else {
        result = json
    }

    return result
}

export { camelizeJson }
